export default __webpack_public_path__ + "static/media/deliveryMan.58d8d7df.svg";